import { render, staticRenderFns } from "./nursePresAddWt.vue?vue&type=template&id=5df7872c&scoped=true&"
import script from "./nursePresAddWt.vue?vue&type=script&lang=ts&"
export * from "./nursePresAddWt.vue?vue&type=script&lang=ts&"
import style0 from "./nursePresAddWt.vue?vue&type=style&index=0&id=5df7872c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7872c",
  null
  
)

export default component.exports